// extracted by mini-css-extract-plugin
export var mapTooltip = "styles-module--mapTooltip--2HS-o";
export var dark = "styles-module--dark--1NTfE";
export var darkModeIconFill = "styles-module--darkModeIconFill--1gBgj";
export var lightModeIconFill = "styles-module--lightModeIconFill--2J0Lm";